import { provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withHashLocation } from '@angular/router';
import { TranslationsFormatter } from '@shared/formatters/translations-formatter';
import { SuperUserGuard } from '@shared/guards/super-user.guard';
import { SuperUserTenantGuard } from '@shared/guards/super-user-tenant.guard';
import { UserGuard } from '@shared/guards/user.guard';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { AuthTokenHandler } from './modules/auth/services/auth-token-handler.service';
import { AuthSessionDeleter } from './modules/auth/services/auth-user-session-deleter.service';
import { TokenChecker } from './modules/auth/services/token-checker.service';
import { TokenExpiryChecker } from './modules/auth/services/token-expiry-checker.service';
import { TokenLoader } from './modules/auth/services/token-loader.service';
import { AsyncTranslationsFinderFetcher } from './modules/management/pages/translations/fetchers/async-translations-finder-fetcher';
import { ApplicationTranslationsFinder } from './modules/management/pages/translations/services/application-translations-finder.service';
import { AsyncUserFinderFetcher } from './modules/user/fetchers/async-user-finder-fetcher';

export function loadTranslations(
  applicationTranslationsFinder: ApplicationTranslationsFinder,
) {
  return async (): Promise<void> => {
    await applicationTranslationsFinder.run();
  };
}

const guards = [UserGuard, SuperUserGuard, SuperUserTenantGuard];
const tokenProviders = [
  TokenLoader,
  TokenExpiryChecker,
  TokenChecker,
  AuthTokenHandler,
];
const authProviders = [AuthSessionDeleter, AsyncUserFinderFetcher];
const translationsProvider = [
  ApplicationTranslationsFinder,
  AsyncTranslationsFinderFetcher,
  TranslationsFormatter,
];
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withHashLocation()),
    provideHttpClient(),
    provideAnimations(),
    provideToastr(),
    ...tokenProviders,
    ...guards,
    ...authProviders,
    ...translationsProvider,
    provideAnimationsAsync(),
    {
      provide: APP_INITIALIZER,
      useFactory: loadTranslations,
      deps: [ApplicationTranslationsFinder],
      multi: true,
    },
  ],
};
